/**
 * Compatibility layer providing Next.js-like navigation hooks backed by react-router-dom.
 * Drop-in replacement for imports from 'next/navigation'.
 */
import {
  useNavigate,
  useParams as useRRParams,
  useSearchParams as useRRSearchParams,
  useLocation,
} from 'react-router-dom'

export function useRouter() {
  const navigate = useNavigate()
  return {
    push: (path: string) => navigate(path),
    replace: (path: string) => navigate(path, { replace: true }),
    back: () => navigate(-1),
    forward: () => navigate(1),
    refresh: () => navigate(0),
    prefetch: (_href: string) => {},
  }
}

export function useParams<T extends Record<string, string> = Record<string, string>>() {
  return useRRParams() as T
}

export function useSearchParams() {
  const [searchParams] = useRRSearchParams()
  return searchParams
}

export function usePathname() {
  const { pathname } = useLocation()
  return pathname
}
